import React, { createContext, useState, useEffect } from 'react';
import apiRequest from '../lib/apiRequest';
import logger from '../lib/logger';
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);
    const [language, setLanguage] = useState('en');
    const checkSessionValidity = async () => {
        try {
            const res = await apiRequest('/check-session');
            const data = res.data;
            if (!data.isValid) {
                // Session invalid, log out
                logout();
            } else {
                // Session valid, update user state
                setIsLoggedIn(true);
                setUser(data.user);
            }
        } catch (err) {
            logger.error('Error checking session validity', err);
            // If there's an error, also log out or handle as needed
            logout();
        } finally {
            setLoadingAuth(false); // Set loading to false after checking session
        }
    };
    // On initial load, check if user info is in local storage

    useEffect(() => {
        checkSessionValidity();
        const userLang = navigator.language || navigator.userLanguage;
        if (userLang.startsWith('zh')) {
            setLanguage('zh');
          } 
    }, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps


    // Call this after successful login or registration
    const login = (userData) => {
        setIsLoggedIn(true);
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
    };
    const updateUser = (userData) => {
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
    }
    // Call this when user clicks “Logout”
    // e.g., using Axios:
    const handleLogout = async () => {
        try {
            // Make sure you include { withCredentials: true } so the cookie is sent
            await apiRequest.post('/auth/logout', {});
            // Now clear local state, localStorage, etc.
            setIsLoggedIn(false);
            setUser(null);
            localStorage.removeItem('user');
        } catch (error) {
            logger.error('Logout failed:', error);
        }
    };
    const logout = async () => {
        await handleLogout();
    }
    return (
        <AuthContext.Provider value={{ language, isLoggedIn, user, loadingAuth, login, logout, updateUser }}>
            {children}
        </AuthContext.Provider>
    );
};
